import "./05_component.css"

export default function Component05() {
    return (
        <div className="SubSection-Main"> 
            <p>Real growth starts with strategy.</p>
            <h2>
                Where strategy, <span>creativity</span>, and growth come together.
            </h2>
            <p className="Leading">
                Adstrate — a strategy-first agency focused on real business growth.
            </p>
            <a href="/quotation"><button>Get Quote</button></a>
        </div>
    );
}